// extracted by mini-css-extract-plugin
export default {"wrapper":"+AZkxKcc0z","header":"dRamKb1TVl","title-message":"uHoP62CVOX","titleMessage":"uHoP62CVOX","change-location":"efCmdLH0SC","changeLocation":"efCmdLH0SC","map-disabled":"EkiyWo5WIE","mapDisabled":"EkiyWo5WIE"};
    if(module.hot) {
      // 1648553820707
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  